export const APPLICATION_STARTUP_MARKS = Object.freeze({
  entryLoaded: 'forumandlex:startup:entry-loaded',
  authenticatedRuntimeLoaded: 'forumandlex:startup:authenticated-runtime-loaded',
  authenticationReady: 'forumandlex:startup:authentication-ready',
  pluginCatalogReady: 'forumandlex:startup:plugin-catalog-ready',
  shellCommitted: 'forumandlex:startup:shell-committed',
});

export type ApplicationStartupPhase = keyof typeof APPLICATION_STARTUP_MARKS;

export function markApplicationStartupPhase(phase: ApplicationStartupPhase): void {
  if (typeof performance === 'undefined' || typeof performance.mark !== 'function') return;
  const mark = APPLICATION_STARTUP_MARKS[phase];
  if (performance.getEntriesByName(mark, 'mark').length > 0) return;
  performance.mark(mark);
}
